import React, { useEffect, useRef, useState } from "react";
import {
  FiCheck,
  FiChevronLeft,
  FiChevronRight,
  FiEdit2,
  FiPlus,
  FiUploadCloud,
  FiFileText,
} from "react-icons/fi";
import FormModal from "../../FormModal";
import FormDrawer from "../../FormDrawer";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import {
  getUserDetails,
  updateTier2KycInfo,
  uploadTier2KycDocument,
  submitTier2Kyc,
  updatingKycDetails,
  verifyGovtID,
} from "../../../actions/user";
import { capitalizeEachWord, formatLabel, getFormattedAmount } from "../../../actions/payments";
import { handleValidationError } from "../../../actions/validation";
import { Field } from "../../FormComponents/Field";
import { CountrySelect } from "../../FormComponents/CountrySelect";


const IndividualKyc = ({ userDetails }) => {
  const dispatch = useDispatch();
  const kycVerification = userDetails?.kyc_profile?.current_verification;
  const isBusinessAccount = userDetails?.account_type === "business";
  const [sdkLoaded, setSdkLoaded] = useState(false);

  console.log("Compliance component userDetails", userDetails);

  const [kycData, setKycData] = useState({
    email: "",
    full_name: "",
    nationality: "",
    date_of_birth: "",
    bvn: "",
    selfie: "",
    id_back: "",
    id_front: "",
  });

  const kycProfile = userDetails?.kyc_profile;

  const govtIdVerifications = userDetails?.kyc_profile?.kyc_verifications?.filter(item => item.status == 'approved' && item.verification_type && (item.verification_type.toLowerCase() != 'bvn' || item?.kyc_data?.nin != null));
  const idVerification = govtIdVerifications?.length > 0 ? govtIdVerifications[0]?.kyc_data : null;

  const openDojahKycWidget = async (data) => {
    if (!sdkLoaded || !window.Connect) {
      // console.error("Dojah SDK not loaded yet.");
      return;
    }

    const options = {
      app_id: data.widget_config.app_id,
      p_key: data.widget_config.public_key,
      type: "custom",
      metadata: {
        user_id: userDetails?.id,
        kyc_verification_id: data.kyc_verification_record.reference_id,
      },
      config: { widget_id: data.widget_config.widget_id, webhook: true },
      onSuccess: async (response) => {
        const credential = {
          reference_id: data.kyc_verification_record.reference_id,
        };
        await updatingKycDetails(credential, dispatch, toast);
        toast.success("Your ID verification has been submitted successfully for processing.");
      },
      onError: (err) => console.error("Error:", err),
      onClose: () => console.log("User closed the widget"),
    };

    const connect = new window.Connect(options);
    connect.setup();
    connect.open();
  };

  const handleAccountUpgrade = async (data) => {
    const kycProvider = data.kyc_verification_record.provider;
    if (kycProvider === "dojah") {
      openDojahKycWidget(data);
    }
  };

  useEffect(() => {
    if (kycVerification?.provider === "dojah") {
      const kycDetails = kycVerification.kyc_data;
      const bvn = kycDetails?.government_data?.data?.bvn?.entity?.bvn;
      const nin = kycDetails?.government_data?.data?.nin?.entity.nin;
      setKycData({
        email: kycDetails?.email?.data?.email,
        full_name: userDetails?.full_name,
        nationality: kycDetails?.countries?.data?.country,
        date_of_birth: userDetails?.date_of_birth,
        bvn: bvn ? bvn.slice(-4).padStart(bvn.length, '*') : null,
        nin: nin ? nin.slice(-4).padStart(nin.length, '*') : null,
        nin_image: kycDetails?.government_data?.data?.nin?.entity?.image_url,
        selfie: kycDetails?.selfie?.data?.selfie_url,
        id_back: kycDetails?.id?.data?.id_url,
        id_front: kycDetails?.id?.data?.back_url,
        id_data: kycDetails?.id?.data?.id_data, //first_name, last_name, nationality, mrz_status, expiry_date, document_type, document_number
        address: kycDetails?.address?.data?.location?.address_location?.name,
      });
    } else if (kycVerification?.provider === "vove_id") {
      setKycData({
        email: "",
        full_name: "",
        nationality: "",
        date_of_birth: "",
        bvn: "",
        selfie: "",
        id_back: "",
        id_front: "",
      });
    }
  }, [kycVerification, userDetails?.date_of_birth, userDetails?.full_name]);

  /** Load Dojah SDK dynamically */
  useEffect(() => {
    const scriptId = "dojah-sdk-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://widget.dojah.io/websdk.js";
      script.defer = true;
      script.onload = () => setSdkLoaded(true);
      document.body.appendChild(script);
    } else {
      setSdkLoaded(true);
    }
  }, []);

  // Clean up any unmounted modal backdrops when leaving the compliance page
  useEffect(() => {
    return () => {
      if (!document.querySelector(".modal.show") && !document.querySelector(".offcanvas.show")) {
        document.querySelectorAll(".modal-backdrop, .offcanvas-backdrop").forEach((el) => el.remove());
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
      }
    };
  }, []);


  if (!userDetails?.kyc_profile || userDetails?.kyc_profile?.status != 'approved') {
    return (
      <section className='create__card__page cardList__page'>
        <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ minHeight: "60vh" }}>
          <h4 className="mb-3">KYC Compliance Pending</h4>
          <p className="text-muted mb-4" style={{ maxWidth: "400px", margin: "0 auto" }}>
            Your KYC verification is pending. Complete it to enjoy full access to your account.
          </p>
          <button className="btn d-flex align-items-center justify-content-center gap-2 shadow-sm mx-auto mt-3"
            style={{ width: '220px', backgroundColor: '#0A95FF', color: '#fff', borderRadius: '12px', padding: '12px 0', fontWeight: '500' }}
            data-bs-toggle="modal"
            data-bs-target="#kycModal"
          >
            Verify KYC Now
          </button>
        </div>
      </section>
    );
  } else {
    return (
      <>
        <div className="row">
          <div className="p-4 pt-0 rounded shadow-sm">
            <div className="bankInfo-heading d-flex flex-wrap justify-content-between align-items-center mb-3">
              <div>
                <h5 className="">Compliance Information</h5>
                {!kycVerification && (
                  <p> You are yet to complete your KYC verification.{" "} </p>)}
              </div>
            </div>

            <div className="row justify-content-between mb-1">
              <div className="bank-details col-11">
                <div className="d-flex flex-wrap justify-content-between align-items-center position-relative">
                  <div>
                    <h6 className="mb-1"> Legal Name </h6>
                    <p className=""> {capitalizeEachWord(kycData.full_name) || "N/A"} </p>
                  </div>

                  <div>
                    <h6 className="mb-1 me-2"> Email Address </h6>
                    <p className=" me-2"> {kycData.email || "N/A"} </p>
                  </div>

                  <div>
                    <h6 className="mb-1 me-2"> Date of Birth </h6>
                    <p className=" me-2"> {kycData.date_of_birth || "N/A"} </p>
                  </div>

                  {kycProfile?.verified_bvn && (
                    <div>
                      <h6 className="mb-1"> BVN </h6>
                      <p className=""> {kycProfile.verified_bvn} </p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mb-1 mt-5">
              <div className="bank-details col-11">
                <h5 className="mb-3 mt-1"> Government ID Verification </h5>
                {userDetails?.kyc_profile?.has_verified_id_document && idVerification ? <>
                  <div className="d-flex flex-wrap justify-content-between align-items-center position-relative">
                    {idVerification.first_name && <div className="">
                      <h6 className="mb-1 me-2"> First Name </h6>
                      <p className=" me-2"> {capitalizeEachWord(idVerification.first_name)} </p>
                    </div>}

                    {idVerification.last_name && <div className="">
                      <h6 className="mb-1 me-2"> Last Name </h6>
                      <p className=" me-2"> {capitalizeEachWord(idVerification.last_name)} </p>
                    </div>}

                    {idVerification.middle_name && <div className="">
                      <h6 className="mb-1 me-2"> Middle Name </h6>
                      <p className=" me-2"> {capitalizeEachWord(idVerification.middle_name)} </p>
                    </div>}

                    {idVerification.date_of_birth && <div className="">
                      <h6 className="mb-1 me-2"> Date of Birth </h6>
                      <p className=" me-2"> {idVerification.date_of_birth} </p>
                    </div>}

                    <div className="">
                      <h6 className="mb-1 me-2"> Nationality </h6>
                      <p className=" me-2"> {idVerification.birth_country || "N/A"} </p>
                    </div>

                    {idVerification.nin && <div className="">
                      <h6 className="mb-1 me-2"> NIN </h6>
                      <p className=" me-2"> {idVerification.nin} </p>
                    </div>}
                  </div>
                </> : <>
                  <p className="me-2">
                    You are yet to complete your goverment-issued ID verification
                  </p>
                  <button
                    className="btn addBank-btn d-flex align-items-center gap-2 mb-4"
                    data-bs-toggle="modal"
                    data-bs-target="#governmentIDVerificationModal"
                  >
                    <span> Verify ID Document </span>
                  </button>
                </>}
              </div>
            </div>
          </div>

          <div className="p-4 rounded shadow-sm mt-3">
            {!userDetails?.kyc_tier_two_profile && <div className="bankInfo-heading d-flex flex-wrap justify-content-between align-items-center mb-3">
              <div>
                <h5 className=""> Tier 2 KYC Verification </h5>
                <p className="col-md-8 col-sm-12">
                  Complete your Tier 2 verification by providing your additional personal and
                  address details to access more features on your account.{" "}
                </p>
                <button
                  className="btn addBank-btn d-flex align-items-center gap-2 mb-4"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#addressVerificationDrawer"
                > Start Verification</button>
              </div>
            </div>}

            {userDetails?.kyc_tier_two_profile && <div className="row mb-1">
              <div className="bank-details col-11">
                <h5 className="mb-3 mt-1"> Address Information </h5>
                <div className="">
                  <h6 className="mb-1 me-2"> Address </h6>
                  <p className=" me-2"> {userDetails?.kyc_tier_two_profile?.address} </p>
                </div>
                <div className="d-flex flex-wrap justify-content-between align-items-center position-relative">
                  <div className="">
                    <h6 className="mb-1 me-2"> City </h6>
                    <p className=" me-2"> {userDetails?.kyc_tier_two_profile?.city} </p>
                  </div>
                  <div className="">
                    <h6 className="mb-1 me-2"> State </h6>
                    <p className=" me-2"> {userDetails?.kyc_tier_two_profile?.state} </p>
                  </div>
                  <div className="">
                    <h6 className="mb-1 me-2"> Postal Code </h6>
                    <p className=" me-2"> {userDetails?.kyc_tier_two_profile?.postal_code} </p>
                  </div>
                  <div className="">
                    <h6 className="mb-1 me-2"> Country </h6>
                    <p className=" me-2"> {userDetails?.kyc_tier_two_profile?.country_code} </p>
                  </div>
                </div>
              </div>

              <div className="bank-details col-11 mt-4">
                <h5 className="mb-3 mt-1"> Income Information </h5>
                <div className="d-flex flex-wrap justify-content-between align-items-center position-relative">
                  <div className="">
                    <h6 className="mb-1 me-2"> Employment Status </h6>
                    <p className=" me-2"> {capitalizeEachWord(userDetails?.kyc_tier_two_profile?.employment_status)} </p>
                  </div>
                  <div className="">
                    <h6 className="mb-1 me-2"> Occupation </h6>
                    <p className=" me-2"> {capitalizeEachWord(userDetails?.kyc_tier_two_profile?.occupation)} </p>
                  </div>
                  <div className="">
                    <h6 className="mb-1 me-2"> Source of Income </h6>
                    <p className=" me-2"> {capitalizeEachWord(userDetails?.kyc_tier_two_profile?.source_of_income)} </p>
                  </div>
                  <div className="">
                    <h6 className="mb-1 me-2"> Monthly Income </h6>
                    <p className=" me-2"> {userDetails?.kyc_tier_two_profile?.income_currency} {getFormattedAmount(userDetails?.kyc_tier_two_profile?.monthly_income)} </p>
                  </div>
                </div>
                <div className="d-flex flex-wrap gap-4">
                  <div className="">
                    <h6 className="mb-1 me-2"> Employer/Benefactor </h6>
                    <p className=" me-2"> {userDetails?.kyc_tier_two_profile?.employer_name} </p>
                  </div>
                  {userDetails?.kyc_tier_two_profile?.employer_email && (
                    <div className="">
                      <h6 className="mb-1 me-2"> Employer Email </h6>
                      <p className=" me-2"> {userDetails?.kyc_tier_two_profile?.employer_email} </p>
                    </div>
                  )}
                  {userDetails?.kyc_tier_two_profile?.employer_mobile_number && (
                    <div className="">
                      <h6 className="mb-1 me-2"> Employer Phone </h6>
                      <p className=" me-2"> {userDetails?.kyc_tier_two_profile?.employer_mobile_number} </p>
                    </div>
                  )}
                </div>
                <button
                  className="btn addBank-btn d-flex align-items-center gap-2 mb-2"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#addressVerificationDrawer"
                > Edit Details </button>
              </div>
            </div>}
          </div>
        </div>

        <GovernmentIDVerification
          kycModalId="governmentIDVerificationModal"
          handleAccountUpgrade={handleAccountUpgrade}
          kycProfile={userDetails?.kyc_profile}
          userIsNigerian={userDetails?.country && userDetails?.country.toLowerCase() == 'nigeria'}
        />

        <AddressVerification
          kycModalId="addressVerificationDrawer"
          handleAccountUpgrade={handleAccountUpgrade}
          userDetails={userDetails}
        />
      </>
    );
  }
}

const GovernmentIDVerification = ({
  kycModalId,
  handleAccountUpgrade,
  kycProfile,
  userIsNigerian
}) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ id_type: '' });
  const [isEdited, setIsEdited] = useState(true);

  const handleChange = (e) => {
    setIsEdited(true);
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const closeBtnRef = useRef(null);

  const initiateGovtIdVerification = async () => {
    setLoading(true);
    try {
      const responseData = await verifyGovtID({
        document_type: form.id_type
      });
      if (
        responseData.status === "success" &&
        responseData.data.proceed === true
      ) {
        handleAccountUpgrade(responseData.data);
        closeBtnRef.current?.click();
        setLoading(false);
      } else {
        toast.error(responseData.message);
      }
    } catch (err) {
      toast.error("An error occurred while trying to upgrade your account.");
      // console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <FormModal
        id={kycModalId}
        title="Verify Government ID"
        onSubmit={initiateGovtIdVerification}
        loading={loading}
        setLoading={setLoading}
        isEdited={isEdited}
        btnText="Proceed"
        processingText="Processing"
        closeBtnRef={closeBtnRef}
      >
        <div className="mb-4">
          <label className="form-label"> Government ID </label>
          <select className="form-control" name="id_type" value={form.id_type} onChange={handleChange} required>
            <option value="">Select Government ID </option>
            {userIsNigerian && <option value="nin"> NIN </option>}
            <option value="national_id"> National ID </option>
            <option value="drivers_license"> Driver's License </option>
            <option value="passport"> International Passport </option>
          </select>
        </div>
      </FormModal>
    </>
  );
};

const SOURCE_OF_INCOME_OPTIONS = [
  "Salary / Employment",
  "Business Ownership",
  "Self-Employment / Freelancing",
  "Contract Work",
  "Family Support / Allowance",
  "Rental Income",
  "Pension / Retirement Benefits",
  "Remittances from Abroad",
  "Investments / Dividends",
  "Government Benefits / Grants",
  "Inheritance",
  "Other",
];

const matchSourceOfIncomeOption = (source) => {
  if (!source) return { selected: "", other: "" };
  const cleanSource = source.toLowerCase().trim();
  const matched = SOURCE_OF_INCOME_OPTIONS.find((opt) => {
    if (opt === "Other") return false;
    const cleanOpt = opt.toLowerCase();
    if (cleanOpt === cleanSource) return true;
    const parts = cleanOpt.split("/").map((p) => p.trim());
    return parts.includes(cleanSource) || cleanSource.startsWith(parts[0]) || cleanOpt.includes(cleanSource);
  });
  if (matched) {
    return { selected: matched, other: "" };
  }
  return { selected: "Other", other: source };
};

const AddressVerification = ({
  kycModalId = "addressVerificationDrawer",
  handleAccountUpgrade,
  userDetails
}) => {
  const dispatch = useDispatch();
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [submittingKyc, setSubmittingKyc] = useState(false);

  const initialSourceMatch = matchSourceOfIncomeOption(userDetails?.kyc_tier_two_profile?.source_of_income);
  const [selectedSourceOption, setSelectedSourceOption] = useState(initialSourceMatch.selected);
  const [otherIncomeSource, setOtherIncomeSource] = useState(initialSourceMatch.other);

  const [form, setForm] = useState({
    address: userDetails?.kyc_tier_two_profile?.address || "",
    city: userDetails?.kyc_tier_two_profile?.city || "",
    state: userDetails?.kyc_tier_two_profile?.state || "",
    postal_code: userDetails?.kyc_tier_two_profile?.postal_code || "",
    country_code: userDetails?.kyc_tier_two_profile?.country_code || "",
    occupation: userDetails?.kyc_tier_two_profile?.occupation || "",
    employment_status: userDetails?.kyc_tier_two_profile?.employment_status || "",
    source_of_income: userDetails?.kyc_tier_two_profile?.source_of_income || "",
    monthly_income: userDetails?.kyc_tier_two_profile?.monthly_income || "",
    employer_name: userDetails?.kyc_tier_two_profile?.employer_name || "",
    employer_email: userDetails?.kyc_tier_two_profile?.employer_email || "",
    employer_mobile_number: userDetails?.kyc_tier_two_profile?.employer_mobile_number || "",
  });

  const [stepOneCompleted, setStepOneCompleted] = useState(
    Boolean(
      userDetails?.kyc_tier_two_profile?.address &&
      userDetails?.kyc_tier_two_profile?.city &&
      userDetails?.kyc_tier_two_profile?.country_code
    )
  );

  // Step 2 Document upload states (upload once at a time)
  const [addressDocFile, setAddressDocFile] = useState(null);
  const [incomeDocFile, setIncomeDocFile] = useState(null);
  const [uploadingDoc, setUploadingDoc] = useState({
    proof_of_address: false,
    proof_of_income: false,
  });
  const [uploadedDocs, setUploadedDocs] = useState({
    proof_of_address: !!userDetails?.kyc_tier_two_profile?.proof_of_address,
    proof_of_income: !!(userDetails?.kyc_tier_two_profile?.proof_of_employment || userDetails?.kyc_tier_two_profile?.proof_of_income),
    proof_of_address_name: userDetails?.kyc_tier_two_profile?.proof_of_address ? "Previously uploaded" : "",
    proof_of_income_name: (userDetails?.kyc_tier_two_profile?.proof_of_employment || userDetails?.kyc_tier_two_profile?.proof_of_income) ? "Previously uploaded" : "",
  });

  useEffect(() => {
    if (userDetails?.kyc_tier_two_profile) {
      setStepOneCompleted(
        Boolean(
          userDetails.kyc_tier_two_profile.address &&
          userDetails.kyc_tier_two_profile.city &&
          userDetails.kyc_tier_two_profile.country_code
        )
      );
      setForm((prev) => ({
        ...prev,
        address: userDetails.kyc_tier_two_profile.address || "",
        city: userDetails.kyc_tier_two_profile.city || "",
        state: userDetails.kyc_tier_two_profile.state || "",
        postal_code: userDetails.kyc_tier_two_profile.postal_code || "",
        country_code: userDetails.kyc_tier_two_profile.country_code || "",
        occupation: userDetails.kyc_tier_two_profile.occupation || "",
        employment_status: userDetails.kyc_tier_two_profile.employment_status || "",
        source_of_income: userDetails.kyc_tier_two_profile.source_of_income || "",
        monthly_income: userDetails.kyc_tier_two_profile.monthly_income || "",
        employer_name: userDetails.kyc_tier_two_profile.employer_name || "",
        employer_email: userDetails.kyc_tier_two_profile.employer_email || "",
        employer_mobile_number: userDetails.kyc_tier_two_profile.employer_mobile_number || "",
      }));
      setUploadedDocs((prev) => ({
        ...prev,
        proof_of_address: prev.proof_of_address || !!userDetails.kyc_tier_two_profile.proof_of_address,
        proof_of_income: prev.proof_of_income || !!(userDetails.kyc_tier_two_profile.proof_of_employment || userDetails.kyc_tier_two_profile.proof_of_income),
      }));

      const savedSource = userDetails.kyc_tier_two_profile.source_of_income || "";
      if (savedSource) {
        const { selected, other } = matchSourceOfIncomeOption(savedSource);
        setSelectedSourceOption(selected);
        setOtherIncomeSource(other);
      }
    }
  }, [userDetails]);

  const [isEdited, setIsEdited] = useState(false);

  const handleChange = (e) => {
    setIsEdited(true);
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const isOtherSelected =
    selectedSourceOption === "Other" ||
    selectedSourceOption === "Others" ||
    Boolean(selectedSourceOption && selectedSourceOption.toLowerCase().startsWith("other"));

  const handleSourceOfIncomeChange = (e) => {
    const val = e.target.value;
    setSelectedSourceOption(val);
    setIsEdited(true);
    if (val === "Other" || val === "Others" || val?.toLowerCase()?.startsWith("other")) {
      setForm((prev) => ({ ...prev, source_of_income: otherIncomeSource || "" }));
    } else {
      setForm((prev) => ({ ...prev, source_of_income: val }));
    }
  };

  const handleOtherIncomeChange = (e) => {
    const val = e.target.value;
    setOtherIncomeSource(val);
    setIsEdited(true);
    setForm((prev) => ({ ...prev, source_of_income: val }));
  };

  const closeBtnRef = useRef(null);

  // Step 1: Save Address & Income Info and proceed to Step 2
  const handleStepOneSubmit = async (e) => {
    e?.preventDefault?.();
    setLoading(true);
    try {
      const payload = {
        address: form.address,
        city: form.city,
        state: form.state,
        postal_code: form.postal_code,
        country_code: form.country_code,
        occupation: form.occupation,
        source_of_income: form.source_of_income,
        monthly_income: form.monthly_income,
        employer_name: form.employer_name,
        employer_email: form.employer_email,
        employer_mobile_number: form.employer_mobile_number,
        employment_status: form.employment_status,
      };

      const responseData = await updateTier2KycInfo(payload);
      if (responseData?.status === "success") {
        toast.success(responseData.message || "Address and income info saved successfully.");
        if (responseData?.data?.user) {
          localStorage.setItem('userDetails', JSON.stringify(responseData.data.user));
          getUserDetails(dispatch);
        }
        setStepOneCompleted(true);
        setIsEdited(false);
        setStep(2);
      } else {
        toast.error(responseData?.message || "Failed to update details.");
      }
    } catch (err) {
      toast.error(err.message || "An error occurred while saving your details.");
    } finally {
      setLoading(false);
    }
  };

  const handleGoToStepTwo = () => {
    if (!stepOneCompleted) {
      toast.warning("Please complete and save Step 1 (Address & Income) first to proceed to Step 2.");
      return;
    }
    if (isEdited) {
      toast.info("Please save your changes in Step 1 first.");
      return;
    }
    setStep(2);
  };

  const handleGoToStepThree = () => {
    if (!stepOneCompleted) {
      toast.warning("Please complete and save Step 1 (Address & Income) first.");
      return;
    }
    if (isEdited) {
      toast.info("Please save your changes in Step 1 first.");
      return;
    }
    if (!uploadedDocs.proof_of_address && !uploadedDocs.proof_of_income) {
      toast.warning("Please upload at least one verification document in Step 2 before proceeding.");
      return;
    }
    setStep(3);
  };

  // Step 2: Upload document one at a time
  const handleUploadDocument = async (docType) => {
    const file = docType === "proof_of_address" ? addressDocFile : incomeDocFile;
    if (!file) {
      toast.error(`Please select a file for ${docType === "proof_of_address" ? "Proof of Address" : "Proof of Income"}.`);
      return;
    }

    setUploadingDoc((prev) => ({ ...prev, [docType]: true }));
    try {
      const fd = new FormData();
      fd.append("document_type", docType);
      fd.append("uploaded_file", file);

      await uploadTier2KycDocument(fd);
      toast.success(`${docType === "proof_of_address" ? "Proof of Address" : "Proof of Income"} uploaded successfully!`);
      setUploadedDocs((prev) => ({
        ...prev,
        [docType]: true,
        [`${docType}_name`]: file.name,
      }));
      if (docType === "proof_of_address") setAddressDocFile(null);
      if (docType === "proof_of_income") setIncomeDocFile(null);
      getUserDetails(dispatch);
    } catch (err) {
      toast.error(err.message || "Failed to upload document.");
    } finally {
      setUploadingDoc((prev) => ({ ...prev, [docType]: false }));
    }
  };

  // Step 3: Final submit KYC (No payload sent to backend)
  const handleSubmitTier2 = async () => {
    if (!uploadedDocs.proof_of_address && !uploadedDocs.proof_of_income) {
      toast.error("Please upload your verification document(s) before submitting.");
      return;
    }

    setSubmittingKyc(true);
    try {
      const responseData = await submitTier2Kyc();
      toast.success(responseData?.message || "Tier 2 KYC submitted successfully for review!");
      // if (responseData?.data?.user) {
      //   localStorage.setItem("userDetails", JSON.stringify(responseData.data.user));
      // }
      getUserDetails(dispatch);
      closeBtnRef.current?.click();
      setTimeout(() => {
        setStep(1);
      }, 350);
    } catch (err) {
      toast.error(err.message || "Failed to submit Tier 2 KYC.");
    } finally {
      setSubmittingKyc(false);
    }
  };

  return (
    <>
      <FormDrawer
        id={kycModalId}
        title="Upgrade Account (Tier 2)"
        subtitle={
          step === 1
            ? "Step 1: Address and income information"
            : step === 2
              ? "Step 2: Upload required verification documents"
              : "Step 3: Review your details and submit"
        }
        onSubmit={step === 1 ? handleStepOneSubmit : undefined}
        loading={loading}
        setLoading={setLoading}
        isEdited={isEdited}
        closeBtnRef={closeBtnRef}
        footer={
          step === 1 ? (
            <button
              type="submit"
              className="primary__btn confirm-walletBtn w-100 mb-4"
              disabled={loading}
            >
              {loading ? (
                <div className="spinner-border spinner-border-sm text-light" role="status">
                  <span className="visually-hidden">Saving...</span>
                </div>
              ) : (
                "Proceed to Document Upload"
              )}
            </button>
          ) : step === 2 ? (
            <div className="d-flex gap-2 mb-4">
              <button
                type="button"
                className="btn btn-outline-secondary w-50 py-2"
                onClick={() => setStep(1)}
              >
                Back to Details
              </button>
              <button
                type="button"
                className="primary__btn confirm-walletBtn w-50"
                onClick={handleGoToStepThree}
                disabled={!uploadedDocs.proof_of_address && !uploadedDocs.proof_of_income}
              >
                Proceed to Review
              </button>
            </div>
          ) : (
            <div className="d-flex gap-2 mb-4">
              <button
                type="button"
                className="btn btn-outline-secondary w-50 py-2"
                onClick={() => setStep(2)}
                disabled={submittingKyc}
              >
                Back to Documents
              </button>
              <button
                type="button"
                className="primary__btn confirm-walletBtn w-50"
                onClick={handleSubmitTier2}
                disabled={submittingKyc || (!uploadedDocs.proof_of_address && !uploadedDocs.proof_of_income)}
              >
                {submittingKyc ? (
                  <div className="spinner-border spinner-border-sm text-light" role="status">
                    <span className="visually-hidden">Submitting...</span>
                  </div>
                ) : (
                  "Confirm & Submit KYC"
                )}
              </button>
            </div>
          )
        }
      >
        {/* Step Progress Bar */}
        <div className="mb-4">
          <div
            className="progress mb-2"
            style={{
              height: "4px",
              backgroundColor: "#e2e8f0",
              borderRadius: "10px",
            }}
          >
            <div
              className="progress-bar bg-primary"
              role="progressbar"
              style={{
                width: step === 1 ? "33.3%" : step === 2 ? "66.6%" : "100%",
                transition: "width 0.3s ease",
              }}
              aria-valuenow={step === 1 ? 33 : step === 2 ? 66 : 100}
              aria-valuemin="0"
              aria-valuemax="100"
            />
          </div>

          {/* Interactive Step Cards */}
          <div className="row g-2">
            <div className="col-4">
              <div
                className={`p-2 rounded-3 border d-flex align-items-center gap-2 ${step === 1
                    ? "border-primary bg-primary bg-opacity-10 shadow-sm"
                    : "border-light-subtle bg-white text-muted"
                  }`}
                style={{ cursor: "pointer", transition: "all 0.2s ease" }}
                onClick={() => setStep(1)}
              >
                <div
                  className={`rounded-circle d-flex align-items-center justify-content-center text-white flex-shrink-0 ${stepOneCompleted && step !== 1 ? "bg-success" : step === 1 ? "bg-primary" : "bg-secondary"
                    }`}
                  style={{ width: 26, height: 26, fontSize: "0.75rem", fontWeight: 700 }}
                >
                  {stepOneCompleted && step !== 1 ? <FiCheck strokeWidth={3} /> : "1"}
                </div>
                <div className="overflow-hidden" style={{ lineHeight: 1.2 }}>
                  <div
                    className="text-uppercase fw-bold"
                    style={{ fontSize: "0.58rem", color: step === 1 ? "var(--primary-color, #0d6efd)" : "#828282" }}
                  >
                    Step 1
                  </div>
                  <div
                    className="text-truncate fw-semibold"
                    style={{ fontSize: "0.75rem", color: step === 1 ? "#1e293b" : "#64748b" }}
                  >
                    Address & Income
                  </div>
                </div>
              </div>
            </div>

            <div className="col-4">
              <div
                className={`p-2 rounded-3 border d-flex align-items-center gap-2 ${step === 2
                    ? "border-primary bg-primary bg-opacity-10 shadow-sm"
                    : !stepOneCompleted
                      ? "border-light-subtle bg-light text-muted opacity-50"
                      : "border-light-subtle bg-white text-muted"
                  }`}
                style={{
                  cursor: stepOneCompleted && !isEdited ? "pointer" : "not-allowed",
                  transition: "all 0.2s ease",
                }}
                onClick={handleGoToStepTwo}
                title={!stepOneCompleted ? "Complete Step 1 first" : isEdited ? "Save Step 1 changes first" : "Go to Step 2"}
              >
                <div
                  className={`rounded-circle d-flex align-items-center justify-content-center text-white flex-shrink-0 ${step === 2
                      ? "bg-primary"
                      : (uploadedDocs.proof_of_address && uploadedDocs.proof_of_income)
                        ? "bg-success"
                        : !stepOneCompleted
                          ? "bg-secondary opacity-50"
                          : "bg-secondary"
                    }`}
                  style={{ width: 26, height: 26, fontSize: "0.75rem", fontWeight: 700 }}
                >
                  {(uploadedDocs.proof_of_address && uploadedDocs.proof_of_income) && step !== 2 ? <FiCheck strokeWidth={3} /> : "2"}
                </div>
                <div className="overflow-hidden" style={{ lineHeight: 1.2 }}>
                  <div
                    className="text-uppercase fw-bold"
                    style={{ fontSize: "0.58rem", color: step === 2 ? "var(--primary-color, #0d6efd)" : "#828282" }}
                  >
                    Step 2
                  </div>
                  <div
                    className="text-truncate fw-semibold"
                    style={{ fontSize: "0.75rem", color: step === 2 ? "#1e293b" : "#64748b" }}
                  >
                    Upload Docs {!stepOneCompleted && <small className="text-muted">(Locked)</small>}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-4">
              <div
                className={`p-2 rounded-3 border d-flex align-items-center gap-2 ${step === 3
                    ? "border-primary bg-primary bg-opacity-10 shadow-sm"
                    : (!stepOneCompleted || (!uploadedDocs.proof_of_address && !uploadedDocs.proof_of_income))
                      ? "border-light-subtle bg-light text-muted opacity-50"
                      : "border-light-subtle bg-white text-muted"
                  }`}
                style={{
                  cursor: stepOneCompleted && !isEdited && (uploadedDocs.proof_of_address || uploadedDocs.proof_of_income) ? "pointer" : "not-allowed",
                  transition: "all 0.2s ease",
                }}
                onClick={handleGoToStepThree}
                title={!stepOneCompleted ? "Complete Step 1 first" : (!uploadedDocs.proof_of_address && !uploadedDocs.proof_of_income) ? "Upload documents first" : "Go to Step 3"}
              >
                <div
                  className={`rounded-circle d-flex align-items-center justify-content-center text-white flex-shrink-0 ${step === 3
                      ? "bg-primary"
                      : "bg-secondary"
                    }`}
                  style={{ width: 26, height: 26, fontSize: "0.75rem", fontWeight: 700 }}
                >
                  3
                </div>
                <div className="overflow-hidden" style={{ lineHeight: 1.2 }}>
                  <div
                    className="text-uppercase fw-bold"
                    style={{ fontSize: "0.58rem", color: step === 3 ? "var(--primary-color, #0d6efd)" : "#828282" }}
                  >
                    Step 3
                  </div>
                  <div
                    className="text-truncate fw-semibold"
                    style={{ fontSize: "0.75rem", color: step === 3 ? "#1e293b" : "#64748b" }}
                  >
                    Review & Submit
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Step 1: Address and Income Information */}
        {step === 1 && (
          <div>
            <div className="mb-4">
              <h6 className="fw-semibold text-secondary text-uppercase mb-3" style={{ fontSize: "0.8rem", letterSpacing: "0.5px" }}>
                Address Information
              </h6>
              <div className="row g-3">
                <div className="col-12">
                  <Field label="Address">
                    <input
                      type="text"
                      className="form-control"
                      value={form.address}
                      name="address"
                      placeholder="Enter street address"
                      onChange={handleChange}
                      required
                    />
                  </Field>
                </div>
                <div className="col-md-6">
                  <Field label="City">
                    <input
                      type="text"
                      className="form-control"
                      value={form.city}
                      name="city"
                      placeholder="Enter city"
                      onChange={handleChange}
                      required
                    />
                  </Field>
                </div>
                <div className="col-md-6">
                  <Field label="State">
                    <input
                      type="text"
                      className="form-control"
                      value={form.state}
                      name="state"
                      placeholder="Enter state"
                      onChange={handleChange}
                      required
                    />
                  </Field>
                </div>

                <div className="col-md-6">
                  <Field label="Postal Code">
                    <input
                      type="text"
                      className="form-control"
                      value={form.postal_code}
                      name="postal_code"
                      placeholder="Enter postal code"
                      onChange={handleChange}
                      required
                    />
                  </Field>
                </div>

                <div className="col-md-6">
                  <Field label="Country">
                    <CountrySelect
                      value={form.country_code}
                      onChange={(iso2) => {
                        setIsEdited(true);
                        setForm((prev) => ({ ...prev, country_code: iso2 }));
                      }}
                    />
                  </Field>
                </div>
              </div>
            </div>

            <div className="mb-2">
              <h6 className="fw-semibold text-secondary text-uppercase mb-3" style={{ fontSize: "0.8rem", letterSpacing: "0.5px" }}>
                Income & Employment Information
              </h6>
              <div className="row g-3">
                <div className="col-md-6">
                  <Field label="Employment Status">
                    <select
                      className="form-control"
                      name="employment_status"
                      value={form.employment_status}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Employment Status</option>
                      <option value="employed">Employed</option>
                      <option value="self_employed">Self Employed</option>
                      <option value="unemployed">Unemployed</option>
                      <option value="student">Student</option>
                      <option value="retired">Retired</option>
                      <option value="freelancer">Freelancer</option>
                    </select>
                  </Field>
                </div>

                <div className="col-md-6">
                  <Field label="Occupation">
                    <input
                      type="text"
                      className="form-control"
                      value={form.occupation}
                      name="occupation"
                      placeholder="e.g. Student, Consultant"
                      onChange={handleChange}
                      required
                    />
                  </Field>
                </div>

                <div className="col-md-6">
                  <Field label="Source of Income">
                    <select
                      className="form-control"
                      name="source_of_income_select"
                      value={selectedSourceOption}
                      onChange={handleSourceOfIncomeChange}
                      required
                    >
                      <option value="">Select Source of Income</option>
                      {SOURCE_OF_INCOME_OPTIONS.map((opt) => (
                        <option key={opt} value={opt}>
                          {opt === "Other" ? "Other (Please Specify)" : opt}
                        </option>
                      ))}
                    </select>

                    {isOtherSelected && (
                      <div className="mt-2">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Please specify your source of income"
                          value={otherIncomeSource === "Other" || otherIncomeSource === "Others" ? "" : otherIncomeSource}
                          onChange={handleOtherIncomeChange}
                          autoFocus
                          required
                        />
                      </div>
                    )}
                  </Field>
                </div>

                <div className="col-md-6">
                  <Field label="Monthly Income">
                    <input
                      type="number"
                      min="0"
                      step="any"
                      className="form-control"
                      value={form.monthly_income}
                      name="monthly_income"
                      placeholder="e.g. 25000"
                      onChange={handleChange}
                      required
                    />
                  </Field>
                </div>

                <div className="col-md-12">
                  <Field label="Employer/Benefactor Name">
                    <input
                      type="text"
                      className="form-control"
                      value={form.employer_name}
                      name="employer_name"
                      placeholder="e.g. Cardplot Technologies"
                      onChange={handleChange}
                      required
                    />
                  </Field>
                </div>

                <div className="col-md-12">
                  <Field label="Employer/Benefactor Email">
                    <input
                      type="email"
                      className="form-control"
                      value={form.employer_email}
                      name="employer_email"
                      placeholder="e.g. employer@company.com"
                      onChange={handleChange}
                      required
                    />
                  </Field>
                </div>

                <div className="col-md-12">
                  <Field label="Employer/Benefactor Mobile Number">
                    <input
                      type="tel"
                      className="form-control"
                      value={form.employer_mobile_number}
                      name="employer_mobile_number"
                      placeholder="e.g. +2348012345678"
                      onChange={handleChange}
                      required
                    />
                  </Field>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Step 2: Upload Tier-Two Documents (Uploaded once at a time) */}
        {step === 2 && (
          <div className="d-flex flex-column gap-3">
            <div className="p-3 rounded bg-light border">
              <p className="mb-0 small text-muted">
                <strong>Note:</strong> Please upload each required document one at a time. Supported formats include PDF, PNG, JPG (maximum 5MB per file).
              </p>
            </div>

            {/* Proof of Address Card */}
            <div className="border rounded p-3 bg-white shadow-sm">
              <div className="d-flex justify-content-between align-items-start mb-2">
                <div>
                  <div className="d-flex align-items-center gap-2">
                    <FiFileText className="text-primary fs-5" />
                    <h6 className="mb-0 fw-bold">Proof of Address</h6>
                  </div>
                  <small className="text-muted d-block mt-1">
                    Utility bill (electricity, water), bank statement, or tenancy agreement issued within the last 3 months.
                  </small>
                </div>
                {uploadedDocs.proof_of_address ? (
                  <span className="badge bg-success d-flex align-items-center gap-1">
                    <FiCheck /> Uploaded
                  </span>
                ) : (
                  <span className="badge bg-secondary">Required</span>
                )}
              </div>

              {uploadedDocs.proof_of_address && uploadedDocs.proof_of_address_name && (
                <div className="small text-success mb-2 d-flex align-items-center gap-1">
                  <FiCheck /> {uploadedDocs.proof_of_address_name}
                </div>
              )}

              <div className="mt-3">
                <input
                  type="file"
                  id="proof_of_address_input"
                  accept=".pdf,.png,.jpg,.jpeg"
                  className="form-control form-control-sm mb-2"
                  onChange={(e) => setAddressDocFile(e.target.files?.[0] || null)}
                />
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary d-flex align-items-center gap-2"
                  onClick={() => handleUploadDocument("proof_of_address")}
                  disabled={!addressDocFile || uploadingDoc.proof_of_address}
                >
                  {uploadingDoc.proof_of_address ? (
                    <>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                      <span>Uploading Proof of Address...</span>
                    </>
                  ) : (
                    <>
                      <FiUploadCloud />
                      <span>{uploadedDocs.proof_of_address ? "Re-upload Proof of Address" : "Upload Proof of Address"}</span>
                    </>
                  )}
                </button>
              </div>
            </div>

            {/* Proof of Income Card */}
            <div className="border rounded p-3 bg-white shadow-sm">
              <div className="d-flex justify-content-between align-items-start mb-2">
                <div>
                  <div className="d-flex align-items-center gap-2">
                    <FiFileText className="text-primary fs-5" />
                    <h6 className="mb-0 fw-bold">Proof of Income</h6>
                  </div>
                  <small className="text-muted d-block mt-1">
                    Recent payslip, bank account statement showing income/salary, or scholarship/employment letter.
                  </small>
                </div>
                {uploadedDocs.proof_of_income ? (
                  <span className="badge bg-success d-flex align-items-center gap-1">
                    <FiCheck /> Uploaded
                  </span>
                ) : (
                  <span className="badge bg-secondary">Required</span>
                )}
              </div>

              {uploadedDocs.proof_of_income && uploadedDocs.proof_of_income_name && (
                <div className="small text-success mb-2 d-flex align-items-center gap-1">
                  <FiCheck /> {uploadedDocs.proof_of_income_name}
                </div>
              )}

              <div className="mt-3">
                <input
                  type="file"
                  id="proof_of_income_input"
                  accept=".pdf,.png,.jpg,.jpeg"
                  className="form-control form-control-sm mb-2"
                  onChange={(e) => setIncomeDocFile(e.target.files?.[0] || null)}
                />
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary d-flex align-items-center gap-2"
                  onClick={() => handleUploadDocument("proof_of_income")}
                  disabled={!incomeDocFile || uploadingDoc.proof_of_income}
                >
                  {uploadingDoc.proof_of_income ? (
                    <>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                      <span>Uploading Proof of Income...</span>
                    </>
                  ) : (
                    <>
                      <FiUploadCloud />
                      <span>{uploadedDocs.proof_of_income ? "Re-upload Proof of Income" : "Upload Proof of Income"}</span>
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Step 3: Review Details and Submit */}
        {step === 3 && (
          <div className="d-flex flex-column gap-3">
            <div className="p-3 rounded bg-primary bg-opacity-10 border border-primary-subtle">
              <div className="d-flex align-items-center gap-2 mb-1">
                <FiFileText className="text-primary fs-5" />
                <h6 className="mb-0 fw-bold text-primary">Review Your KYC Details</h6>
              </div>
              <p className="mb-0 small text-muted">
                Please verify that your personal, employment, and uploaded documents are correct before final submission.
              </p>
            </div>

            {/* Address Information Summary Card */}
            <div className="border rounded-3 p-3 bg-white shadow-sm">
              <div className="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
                <h6 className="fw-bold mb-0 text-dark" style={{ fontSize: "0.9rem" }}>
                  Residential Address
                </h6>
                <button
                  type="button"
                  className="btn btn-sm btn-link text-primary text-decoration-none p-0 d-flex align-items-center gap-1"
                  onClick={() => setStep(1)}
                  style={{ fontSize: "0.8rem", fontWeight: 600 }}
                >
                  <FiEdit2 size={13} /> Edit
                </button>
              </div>

              <div className="row g-2" style={{ fontSize: "0.85rem" }}>
                <div className="col-12">
                  <span className="text-muted d-block" style={{ fontSize: "0.75rem" }}>Street Address</span>
                  <span className="fw-semibold text-dark">{form.address || "—"}</span>
                </div>
                <div className="col-6">
                  <span className="text-muted d-block" style={{ fontSize: "0.75rem" }}>City</span>
                  <span className="fw-semibold text-dark">{form.city || "—"}</span>
                </div>
                <div className="col-6">
                  <span className="text-muted d-block" style={{ fontSize: "0.75rem" }}>State / Province</span>
                  <span className="fw-semibold text-dark">{form.state || "—"}</span>
                </div>
                <div className="col-6">
                  <span className="text-muted d-block" style={{ fontSize: "0.75rem" }}>Postal Code</span>
                  <span className="fw-semibold text-dark">{form.postal_code || "—"}</span>
                </div>
                <div className="col-6">
                  <span className="text-muted d-block" style={{ fontSize: "0.75rem" }}>Country Code</span>
                  <span className="fw-semibold text-dark">{form.country_code || "—"}</span>
                </div>
              </div>
            </div>

            {/* Income & Employment Summary Card */}
            <div className="border rounded-3 p-3 bg-white shadow-sm">
              <div className="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
                <h6 className="fw-bold mb-0 text-dark" style={{ fontSize: "0.9rem" }}>
                  Income & Employment
                </h6>
                <button
                  type="button"
                  className="btn btn-sm btn-link text-primary text-decoration-none p-0 d-flex align-items-center gap-1"
                  onClick={() => setStep(1)}
                  style={{ fontSize: "0.8rem", fontWeight: 600 }}
                >
                  <FiEdit2 size={13} /> Edit
                </button>
              </div>

              <div className="row g-2" style={{ fontSize: "0.85rem" }}>
                <div className="col-6">
                  <span className="text-muted d-block" style={{ fontSize: "0.75rem" }}>Employment Status</span>
                  <span className="fw-semibold text-dark text-capitalize">
                    {form.employment_status?.replace(/_/g, " ") || "—"}
                  </span>
                </div>
                <div className="col-6">
                  <span className="text-muted d-block" style={{ fontSize: "0.75rem" }}>Occupation</span>
                  <span className="fw-semibold text-dark">{form.occupation || "—"}</span>
                </div>
                <div className="col-6">
                  <span className="text-muted d-block" style={{ fontSize: "0.75rem" }}>Source of Income</span>
                  <span className="fw-semibold text-dark">{form.source_of_income || "—"}</span>
                </div>
                <div className="col-6">
                  <span className="text-muted d-block" style={{ fontSize: "0.75rem" }}>Monthly Income</span>
                  <span className="fw-semibold text-dark">
                    {form.monthly_income ? Number(form.monthly_income).toLocaleString() : "—"}
                  </span>
                </div>
                <div className="col-6">
                  <span className="text-muted d-block" style={{ fontSize: "0.75rem" }}>Employer / Benefactor</span>
                  <span className="fw-semibold text-dark">{form.employer_name || "—"}</span>
                </div>
                <div className="col-6">
                  <span className="text-muted d-block" style={{ fontSize: "0.75rem" }}>Employer Email</span>
                  <span className="fw-semibold text-dark text-truncate d-block" title={form.employer_email}>
                    {form.employer_email || "—"}
                  </span>
                </div>
                <div className="col-12">
                  <span className="text-muted d-block" style={{ fontSize: "0.75rem" }}>Employer Mobile</span>
                  <span className="fw-semibold text-dark">{form.employer_mobile_number || "—"}</span>
                </div>
              </div>
            </div>

            {/* Uploaded Documents Summary Card */}
            <div className="border rounded-3 p-3 bg-white shadow-sm">
              <div className="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
                <h6 className="fw-bold mb-0 text-dark" style={{ fontSize: "0.9rem" }}>
                  Verification Documents
                </h6>
                <button
                  type="button"
                  className="btn btn-sm btn-link text-primary text-decoration-none p-0 d-flex align-items-center gap-1"
                  onClick={() => setStep(2)}
                  style={{ fontSize: "0.8rem", fontWeight: 600 }}
                >
                  <FiEdit2 size={13} /> Edit
                </button>
              </div>

              <div className="d-flex flex-column gap-2" style={{ fontSize: "0.85rem" }}>
                <div className="d-flex justify-content-between align-items-center p-2 rounded bg-light border">
                  <div>
                    <div className="fw-semibold text-dark">Proof of Address</div>
                    <small className="text-muted">
                      {uploadedDocs.proof_of_address_name || (uploadedDocs.proof_of_address ? "Document uploaded" : "Not uploaded")}
                    </small>
                  </div>
                  {uploadedDocs.proof_of_address ? (
                    <span className="badge bg-success d-flex align-items-center gap-1">
                      <FiCheck size={12} /> Uploaded
                    </span>
                  ) : (
                    <span className="badge bg-secondary">Missing</span>
                  )}
                </div>

                <div className="d-flex justify-content-between align-items-center p-2 rounded bg-light border">
                  <div>
                    <div className="fw-semibold text-dark">Proof of Income</div>
                    <small className="text-muted">
                      {uploadedDocs.proof_of_income_name || (uploadedDocs.proof_of_income ? "Document uploaded" : "Not uploaded")}
                    </small>
                  </div>
                  {uploadedDocs.proof_of_income ? (
                    <span className="badge bg-success d-flex align-items-center gap-1">
                      <FiCheck size={12} /> Uploaded
                    </span>
                  ) : (
                    <span className="badge bg-secondary">Missing</span>
                  )}
                </div>
              </div>
            </div>

            {/* Compliance Statement Note */}
            <div className="p-2 rounded bg-light border">
              <p className="mb-0 text-muted" style={{ fontSize: "0.78rem" }}>
                By clicking <strong>Confirm & Submit KYC</strong>, you certify that all information submitted is true, accurate, and complete. Your application will be queued for compliance review.
              </p>
            </div>
          </div>
        )}
      </FormDrawer>
    </>
  );
};


export default IndividualKyc;
